import tearFundLogo from 'app/modules/web-shop/sub-modules/landing-module/components/testimonials-block/TF_Tearfund_Logo.png';
import issLogo from 'app/modules/web-shop/sub-modules/landing-module/components/testimonials-block/iss_logo.png';

export interface TestimonialsDataProps {
  title: string;
  body: string;
  companyLogo: string;
  authorName: string;
  authorRole: string;
}

export const TestimonialsData: TestimonialsDataProps[] = [
  {
    title:
      '<h3>Worked like a charm so I recommend using AIDA as a publishing tool!</h3>',
    body: '<p>AIDA provides you with the right toolkit to start entering data. Using the AIDA Data Services and the spreadsheet templates I was able to publish my data in just one week to meet the donor deadline. Having a good overview of your project and some proficiency in using spreadsheets is needed for data entry, but uploading my report to the platform afterwards was easy and having a validation check is a valuable aspect.</p> <p> While initially I had some trouble understanding how my IATI structure should look like, it went very well with the assistance of the helpdesk support. Overall it worked like a charm so I recommend using AIDA as a publishing tool!</p>',
    companyLogo: `<img src=${tearFundLogo} alt="Tear fund logo" />`,
    authorName: '<h4>Sander Venema</h4>',
    authorRole: '<h5>Project Controller at Tearfund NL, May 2022</h5>',
  },

  {
    title:
      '<h3> "AIDA is a practical and easy to use tool to complete the donor reporting obligations, <br/> timely and accurately. It is refreshing to see how the tool has evolved <br/> to drive better and more efficient services to its customers, <br/> specially the validation functionality" </h3>',
    body: '<p></p>',
    companyLogo: `<img src=${issLogo} alt="Tear fund logo" />`,
    authorName: '<h4>Thavan Rajoo</h4>',
    authorRole: '<h5>Director of Finance as ISS</h5>',
  },
  // {
  //   title: '<h3>Slide 2</h3>',
  //   body: '<p>Carousel slide 2. Using the AIDA Data Services and the spreadsheet templates I was able to publish my data in just one week to meet the donor deadline. Having a good overview of your project and some proficiency in using spreadsheets is needed for data entry, but uploading my report to the platform afterwards was easy and having a validation check is a valuable aspect.</p> <p> While initially I had some trouble understanding how my IATI structure should look like, it went very well with the assistance of the helpdesk support. Overall it worked like a charm so I recommend using AIDA as a publishing tool!</p>',
  //   companyLogo: `<img src=${tearFundLogo} alt="Tear fund logo" />`,
  //   authorName: '<h4>Sander Venema</h4>',
  //   authorRole: '<h5>Project Controller at Tearfund NL, May 2022</h5>',
  // },
  // {
  //   title: '<h3>slide 3</h3>',
  //   body: '<p>vfdjkvdjkcnkdliodfjkxdbjx . Using the AIDA Data Services and the spreadsheet templates I was able to publish my data in just one week to meet the donor deadline. Having a good overview of your project and some proficiency in using spreadsheets is needed for data entry, but uploading my report to the platform afterwards was easy and having a validation check is a valuable aspect.</p> <p> While initially I had some trouble understanding how my IATI structure should look like, it went very well with the assistance of the helpdesk support. Overall it worked like a charm so I recommend using AIDA as a publishing tool!</p>',
  //   companyLogo: `<img src=${tearFundLogo} alt="Tear fund logo" />`,
  //   authorName: '<h4>Sander Venema</h4>',
  //   authorRole: '<h5>Project Controller at Tearfund NL, May 2022</h5>',
  // },
];
